<div class="header">
  <h2 class="header__title">{{ onboardingData().title }}</h2>
  <app-icon [icon]="iconName.CLOSE" class="header__icon" (click)="onClose()" />
</div>
<div class="content">
  <div class="content__description">
    <h3 class="content__title">{{ onboardingData().headline }}</h3>
    <div class="content__paragraphs" [innerHTML]="onboardingData().detailedText | lineBreak"></div>
    <div class="content__pagination pagination">
      @for (step of lengthArray(); track $index; let i = $index) {
        <button
          class="pagination__btn"
          [class.active]="currentIndex() === i"
          (click)="stepper.selectStepByIndex(i)"
          [attr.aria-label]="'onboarding step ' + (i + 1)"
        ></button>
      }
    </div>
  </div>
  <img
    src="assets/images/onboarding/{{ onboardingData().headline }}.png"
    class="content__image"
    alt="{{ onboardingData().headline }} image page"
  />
</div>
<div class="buttons">
  @if (isLast()) {
    <button class="btn-neutral" id="backButton" cdkStepperPrevious>
      {{ 'onboarding.buttons.back' | translate }}
    </button>
    <button class="btn-primary" id="startButton" (click)="onStart()">
      {{ 'onboarding.buttons.start' | translate }}
    </button>
  } @else {
    <button class="btn-neutral" id="cancelButton" (click)="onStart()">
      {{ 'onboarding.buttons.cancel' | translate }}
    </button>
    <button class="btn-primary" id="nextButton" cdkStepperNext>
      {{ 'onboarding.buttons.next' | translate }}
    </button>
  }
</div>
